<template>
  <div class="select">
    <Datepicker v-model="value"
                :disabledDates="disabledDates"
                inputFormat="dd-MM-yyyy"
                :locale="locale"
                :lowerLimit="lowerLimitHandler"
                :placeholder="placeholder"
                :upperLimit="upperLimitHandler"
                class="select__input"
                />
  </div>
</template>

<script>
import _ from 'lodash';
import Datepicker from 'vue3-datepicker';
import { nl } from 'date-fns/locale';

export default {
  name: 'DatePicker',

  components: {
    Datepicker,
  },

  props: {
    availableDates: {
      type: Array,
    },
    lowerLimit: {
      type: Date,
    },
    modelValue: {
      type: Date,
    },
    placeholder: {
      type: String,
    },
    upperLimit: {
      type: Date,
    },
  },

  data: () => ({
    locale: nl,
  }),

  computed: {
    disabledDates() {
      const disabledDates = {
        dates: [],
      };

      if (!this.formattedAvailableDates.length) {
        return disabledDates;
      }

      let currentDate = _.clone(this.lowerLimitHandler);

      while (currentDate <= this.upperLimitHandler) {
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const matchingAvailableDates = this.availableDates.find(
          (availableDate) => availableDate.title === formattedDate,
        );

        if (!matchingAvailableDates) {
          disabledDates.dates.push(currentDate);
        }

        const newDate = currentDate.getDate() + 1;
        currentDate = new Date(currentDate.valueOf());
        currentDate.setDate(newDate);
      }

      return disabledDates;
    },

    formattedAvailableDates() {
      return this.availableDates.map((availableDate) => {
        const dateParts = availableDate.title.split('-');
        return new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
      });
    },

    lowerLimitHandler() {
      if (this.lowerLimit) {
        return this.lowerLimit;
      }
      if (this.formattedAvailableDates.length) {
        return this.formattedAvailableDates[0];
      }
      return null;
    },

    upperLimitHandler() {
      if (this.upperLimit) {
        return this.upperLimit;
      }

      const { formattedAvailableDates } = this;
      const formattedAvailableDatesAmount = formattedAvailableDates.length;

      if (formattedAvailableDatesAmount) {
        return formattedAvailableDates[formattedAvailableDatesAmount - 1];
      }
      return null;
    },

    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit(
          'update:modelValue',
          new Date(Date.UTC(
            value.getFullYear(),
            value.getMonth(),
            value.getDate(),
          )),
        );
      },
    },
  },
};
</script>

<style lang="scss">
  @import '@/assets/css/select.scss';

  .select {

    &__input {
      height: var(--select-height);

      &::placeholder {
        color: black;
      }
    }
  }
</style>
